export default {
      id: "icon-office-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/icons.svg#icon-office",
      toString: function () {
        return this.url;
      }
    }